import { BaseModel } from '@/models/base'

export class User extends BaseModel {
  constructor (
    public id: number,
    public name: string,
    public cnpj: string
  ) { super(id) }
}
